import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const carrierServiceApiSchema = v.object({
  description: v.string(),
  id: v.number(),
  serviceCode: v.string(),
  serviceKey: v.number(),
});

export const carrierServiceSchema = v.object({
  ...carrierServiceApiSchema.entries,
  ...optionSchema.entries,
});

export const carrierServicesApiSchema = paginatedSchema(carrierServiceApiSchema);

export type CarrierServiceApi = v.InferOutput<typeof carrierServiceApiSchema>;
export type CarrierServicesApi = v.InferOutput<typeof carrierServicesApiSchema>;

export type CarrierServiceFilters = Filters<CarrierServiceApi>;

export type CarrierServiceFiltersUpdateApi = FiltersUpdateApi<CarrierServiceApi>;

export type CarrierService = Prettify<Option<v.InferOutput<typeof carrierServiceSchema>>>;

export type CarrierServices = Entities<CarrierService>;
